/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 * Tek kaynak qubepro-core; değişiklikler resmî sync ile dağıtılır.
 */
import type { ReactNode } from 'react';
import './LoginLayout.css';

/** Presentation only: product copy and Core-only provisioning remain with the caller. */
export function LoginLayout({ feature, children, language }: {
  feature: ReactNode;
  children: ReactNode;
  language: string;
}) {
  return <main className="login-container" lang={language} dir={language.split('-')[0] === 'ar' ? 'rtl' : 'ltr'}>
    <div className="login-layout">
      <section className="login-feature-panel">{feature}</section>
      {children}
    </div>
  </main>;
}
